import { message, Modal } from 'antd';
import React, { useContext, useEffect } from 'react';
import { BomDesignerContext } from '../../../contexts/BomDesignerContext';
import BomDesigner from '../../designer/BomDesigner';

const EditBomModel: React.FC<{ modelId?: number, isOpen: boolean, onClose: () => void }> = ({ modelId, isOpen, onClose }) => {
    const {title, save, load, createNew } = useContext(BomDesignerContext);

    const [messageApi, contextHolder] = message.useMessage();

    const onFinish = () => {
        save().then(() => {
            if(modelId){
                messageApi.success("Bom Model updated");
            }else{
                messageApi.success("Bom Model created");
            }
            onClose();
        });
    };

    useEffect(() => {
        if (isOpen) {
            if(modelId){
                load(modelId);
            }else{
                createNew();
            }
        }
    }, [isOpen, modelId, load, createNew]);

    return (
        <>
            {contextHolder}

            <Modal title={`Edit ${title}`} centered width={'calc(100vw - 200px)'} open={isOpen} onClose={onClose} okText="Save" styles={{ body: { overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' } }} onCancel={onClose} onOk={onFinish}>
                <div id="createapp" style={{minHeight: '0'}}>
                    <BomDesigner hideSaveButton onSave={onFinish} />
                </div>
            </Modal>
        </>

    );
};

export default EditBomModel;